import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_k6KPvgRTM32v: {
	id: 'prd_k6KPv2DEV2gRTM32v'
	ident: 'prd_k6KPvgRTM32v'
	sku: 'simple_workbook_bundle_26_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_62e5i2DEV2s7WzJhG'
		amount: 64
		amount_usd: 26
		currency: 'USD'
		amount_with_discount: 26
		discount: 38
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_k6KPvgRTM32v, OneTimeProduct>
const prd_k6KPvgRTM32v = { ident: 'prd_k6KPvgRTM32v' } as typeof _prd_k6KPvgRTM32v

export default prd_k6KPvgRTM32v
